/* WORK TIME ADDITION */
Vue.component('worktimeaddition',{
    template:'#worktimeaddition-template',
    data:function(){
        return{
            clients:[],
            users:[],
            brands:[],
            active_client:{
                brands:{},
            },
            active_client_id:-1,
            active_brand:{
                projects:{}
            },
            active_brand_id:-1,
            active_project:{},
            active_project_id:-1,
            active_ticket:{},
            active_ticket_id:-1,
            active_user:{},
            active_user_id:-1,
            project_number:'-1',
            ticket_number:'-1',
            run_mode:'', // CAN BE regular (THE CURRENT WEEK) OR whole_year (THE WHOLE YEAR) -> FETCHED FROM hidden input #run_mode -> fetched from the env file
            user_day_closed:0,
            selcted_worktime_unit:'',
            date:'',
            duration:'',
            recentWorkTimeAdditions:[],
            workhours_today:0,
            note:'',
            activity_id:'',
            min_date:'',
            user_activities:[],
            worktime_hours:-1,
            worktime_minutes:-1,
            last_url:"",
            last_business_day:null
        };
    },
    created:function(){

        date = moment().format('YYYY[-]MM[-]DD');
        activeInstance = this;
        activeInstance.getClients();
        activeInstance.getLastBusinessDay();


        var id = $('#content_wrapper').attr('data-id');
        activeInstance.getUserWorktimeRecordsForTheDay();
        activeInstance.getUserActivities();
        var date = new Date();

        setTimeout(function(){
            $(function () {

                activeInstance.run_mode = $('#run_mode').val();

                if(activeInstance.run_mode == 'regular'){

                    var minDate = moment().startOf('isoweek');
                    var maxDate = moment().endOf('isoweek');

                    //INITIATE DATETIMEPICKER
                    $('#datetimepicker6').datetimepicker({
                        format: 'YYYY-MM-DD',
                        locale: 'hu',
                        defaultDate:date,
                        maxDate: maxDate,
                        minDate: minDate
                    });
                }
                else if(activeInstance.run_mode == 'whole_year'){

                    //var minDate = moment().startOf('year');
                    var minDate = '2017-01-01';
                    var maxDate = moment().endOf('isoWeek');

                    //INITIATE DATETIMEPICKER
                    $('#datetimepicker6').datetimepicker({
                        format: 'YYYY-MM-DD',
                        locale: 'hu',
                        defaultDate:date,

                        maxDate: maxDate,
                        minDate: minDate

                    });
                }

                setTimeout(function(){
                    var $table = $('.fixed_header_table');
                    $table.floatThead({
                        top:70
                    });
                },200);


                $("#projectnumbersearchfield").val('');
                $("#ticketnumbersearchfield").val('');
                activeInstance.date= moment().format('YYYY[-]MM[-]DD');
            });

            document.title = 'Munkaóra felvitel - ODIN Enterprise Manager';
            $("#page_title").text('MUNKAÓRA FELVITEL');

        },300);

        setTimeout(function(){
            $("#ticketsearchfield").attr('autocomplete','off');
            $("#projectsearchfield").attr('autocomplete','off');
            $("#projectnumbersearchfield").attr('autocomplete','off');
            $("#ticketnumbersearchfield").attr('autocomplete','off');
        },500);

        //activeInstance.checkUserDayStatus();


    },
    events: {
        //ON CLIENT SELECTION
        'autocomplete-result:selected': function(data){

            if( typeof data.project_number !=='undefined' ){
                activeInstance.project_number = data.project_number;
            }

            if( typeof data.division_id !=='undefined'){
                activeInstance.activity_id = data.id;
            }

        },
        'autocomplete-project:selected': function(data){
            console.log(data);
            activeInstance.active_client_id=data.client_id;
            activeInstance.setActiveClient();
            activeInstance.active_brand_id=data.brand_id;
            activeInstance.setActiveBrand();
            activeInstance.active_project_id = data.id;
            activeInstance.project_number = data.project_number;
            setTimeout(function(){
                $('#projectnumbersearchfield').val(data.project_number);
                activeInstance.setActiveProject();
            },200);

        },
        'autocomplete-ticket:selected': function(data){
            console.log(data);
            activeInstance.project_number = data.project_number;
            activeInstance.active_client_id=data.project.client_id;
            activeInstance.setActiveClient();
            activeInstance.active_brand_id=data.project.brand_id;
            activeInstance.setActiveBrand();
            activeInstance.active_project_id = data.project.id;
            setTimeout(function(){
                activeInstance.setActiveProject();
            },200);
            activeInstance.active_ticket_id = data.id;
            setTimeout(function(){
                activeInstance.setActiveTicket();
                $('#ticketnumbersearchfield').val(data.ticket_number);
                $('#projectnumbersearchfield').val(data.project.project_number);
            },200);

        }
    },
    watch: {
        date: function() {
            activeInstance.getUserWorktimeRecordsForTheDay();
        }
    },
    methods:{
        getLastBusinessDay:function(){
          axios.get(baseURL+'/api/timesheet/last_failed_business_day').then(function(response){
            activeInstance.last_business_day = response.data;
            activeInstance.getLastURL();
          });
        },
        getClients:function() {
            showLoadingOverlay();
            axios.get(baseURL + '/api/timesheet/clients_detailed')
                .then(function (response) {
                    $('body').LoadingOverlay("hide");

                    /*
                                        for(var i = 0, i_l = response.data.length; i < i_l; i ++) {

                                            if (response.data[i].id == 20) {
                                                for(var b = 0, b_l = response.data[i].brands.length; b < b_l; b ++) {
                                                    if (response.data[i].brands[b].id == 34) {

                                                        console.log(response.data[i].brands[b].projects);

                                                        var new_arr = [];

                                                        response.data[i].brands[b].projects.filter(function (value) {
                                                            console.log(value);
                                                            return (value.id != 7 || value.id != 8);
                                                        });

                                                        console.log(response.data[i].brands[b].projects);

                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    */

                    activeInstance.clients = response.data;
                });
        },
        getLastURL:function(){
          axios.get(baseURL+'/api/user/last_url')
              .then(function(response){
                activeInstance.last_url = response.data;
                  setTimeout(function(){
                    if(activeInstance.last_url != "" && activeInstance.last_business_day!=""){
                        console.log("setting the last business day");
                        //SET THE DATEPICKER TO THE LAST BUSINESS DAY
                        $('#datetimepicker6').data("DateTimePicker").date(activeInstance.last_business_day);
                        //SET THE FILTER DATE TO LAST BUSINESS DAY
                        activeInstance.date=activeInstance.last_business_day;
                    }
                  },200);
              });
        },
        redirectToLastURL:function(){
            axios.post(baseURL+'/api/user/clear_last_url').then(function(response){
                window.location = activeInstance.last_url;
            });
        },
        getUsers:function(){
            showLoadingOverlay();
            axios.get(baseURL+'/api/timesheet/users')
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    console.log(response.data);
                    activeInstance.users = response.data;
                });
        },
        setActiveClient:function(){
            $.each(activeInstance.clients,function(index,client){

                if(activeInstance.active_client_id == -1){
                    activeInstance.active_client={};
                    activeInstance.active_brand={};
                    activeInstance.active_brand_id=-1;
                    activeInstance.active_project={};
                    activeInstance.active_project_id=-1;
                    activeInstance.project_number='';
                    setTimeout(function(){
                        $('#ticketnumbersearchfield').val('');
                        $('#projectnumbersearchfield').val('');
                        $('#projectsearchfield').val('');
                        $('#ticketsearchfield').val('');

                        $('#projectsearchfield').val('');
                    },150);

                }

                if(client.id == activeInstance.active_client_id){
                    activeInstance.active_client = client;
                }
            });
        },
        setActiveBrand:function(){
            $.each(activeInstance.active_client.brands,function(index,brand){

                if(activeInstance.active_brand_id == -1){
                    activeInstance.active_brand={};
                    activeInstance.active_project={};
                    activeInstance.project_number='';
                    activeInstance.active_project_id=-1;
                }

                if(brand.id == activeInstance.active_brand_id){
                    activeInstance.active_brand = brand;
                }

            });
        },
        setActiveProject:function(){
            $.each(activeInstance.active_brand.projects,function(index,project){

                if(activeInstance.active_project_id == -1){
                    activeInstance.active_project={};
                    activeInstance.active_ticket={};
                    activeInstance.ticket_number = '';
                    activeInstance.project_number = '';
                    $('#ticketnumbersearchfield').val('');
                    $('#projectnumbersearchfield').val('');
                }
                if(project.id == activeInstance.active_project_id){
                    activeInstance.active_project = project;
                    activeInstance.project_number = project.project_number;
                    activeInstance.active_project_id =  project.id;
                    $('#projectnumbersearchfield').val(project.project_number);
                    $('#ticketnumbersearchfield').val('');
                    setTimeout(function(){
                        $('#project_name').val(project.id);
                    },400);

                }

            });
        },
        setActiveTicket:function(){
            $.each(activeInstance.active_project.tickets,function(ticket_index,ticket){
                if(activeInstance.active_ticket_id == -1){
                    activeInstance.ticket_number = '';
                    activeInstance.active_ticket={};
                    $('#ticketnumbersearchfield').val('');
                }
                if(ticket.id == activeInstance.active_ticket_id){
                    activeInstance.active_ticket = ticket;
                    setTimeout(function(){
                        $('#ticketnumbersearchfield').val(ticket.ticket_number);
                    },200);
                    activeInstance.ticket_number = ticket.ticket_number;
                };

            });
        },
        setActiveUser:function(){

        },
        getClientBrands:function(client){
            activeInstance.brands = client.brands;
        },
        undo:function(record){
            bootbox.confirm('Biztosan visszavonod a bejegyzést?', function(value) {
                if (value == true) {
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/undo_workime_addition',{record:record}).then(function(response) {
                        $('body').LoadingOverlay("hide");
                        if(response.data == 'OK'){
                            activeInstance.recentWorkTimeAdditions.$remove(record);
                            successNotification('A bejegyzés visszavonva');
                            activeInstance.getUserWorktimeRecordsForTheDay();
                        }
                        else if( response.data == 'The day is closed')
                        {
                            errorNotification('Lezárt munkanapról nem lehet visszavonni munkaórát.');
                        }
                    });
                }
            });
        },
        checkUserDayStatus:function(){

            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/user/day_status').then(function(response){
                $('body').LoadingOverlay("hide");
                if(response.data == true || response.data==1){
                    $('.closeButton').css('pointer-events','none');
                    $('.processButton').css('pointer-events','none');
                    $('#worktime_addition').addClass('disabled').addClass('faded');
                    activeInstance.user_day_closed = 1;
                }else{

                }
            });
        },
        closeUserDay:function(){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/closeUserDay',{date:activeInstance.date}).then(function(response){
                $('body').LoadingOverlay("hide");

                activeInstance.checkUserDayStatus();
                if(response.data=='not_enough_work_time'){
                    errorNotification('Nincs elegendő munkaóra a lezáráshoz.')
                }
                else if(response.data=='OK'){
                    successNotification('A munkanap sikeresen lezárva');
                    activeInstance.getUserWorktimeRecordsForTheDay();
                    //RESET THE FIELDS
                    activeInstance.project_number = '';
                    activeInstance.duration = 0;
                    activeInstance.note = '';
                    activeInstance.activity_id = '';
                    $('#activitysearch').val('');
                    $('#projectsearch').val('');

                }else{
                    errorNotification(response.data);
                }
            });
        },
        getUserWorktimeRecordsForTheDay:function(){

            showLoadingOverlay();
            /*
            Vue.http.get(baseURL+'/api/user/worktime_records').then(function(response){
                $('body').LoadingOverlay("hide");
                total_workhours = 0;
                $.each(response.data,function(index,timerecord){
                    //console.log(timerecord.duration);
                    total_workhours = parseInt(total_workhours) + parseInt(timerecord.duration);
                });
                activeInstance.recentWorkTimeAdditions = response.data;
                activeInstance.workhours_today = total_workhours;
            }).bind(this);
             */

            axios.post(baseURL+'/api/user/worktime_records',{date:activeInstance.date})
                .then(function(response){
                    $('body').LoadingOverlay("hide");
                    activeInstance.recentWorkTimeAdditions = response.data;
                    activeInstance.workhours_today = total_workhours;
                });

        },
        getUserActivities:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/user/activities').then(function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.user_activities = response.data;
            }).bind(this);
        },
        addWorkTime:function(){

            var validation = true;
            $('.error').removeClass('error');

            //TODO::VALIDATE HERE!!!

            //CHECK IF THE DATE IS IN THE VALID RANGE
            var current_hour = moment().format("H");
            var selected_date = moment(activeInstance.date).format('YYYY[-]MM[-]DD');
            var current_date = moment().format('YYYY[-]MM[-]DD');

            if( selected_date < activeInstance.min_date ){
                validation = false;
                errorNotification('A dátum nem megfelelő');
                $('#field_date').addClass('error');
            }

            if( activeInstance.worktime_hours == -1){
                validation = false;
                errorNotification('Nincs kiválasztva óra.');
                $('#field_hour').addClass('error');
            }

            if( activeInstance.worktime_minutes == -1){
                validation = false;
                errorNotification('Nincs kiválasztva perc.');
                $('#field_minute').addClass('error');
            }

            if( activeInstance.active_project_id == -1 ){
                validation = false;
                errorNotification('Nincs projekt kiválasztva.');
                $('#projectsearchfield').addClass('error');
                $('#projectnumbersearchfield').addClass('error');
                $('#project_name').addClass('error');
            }

            if( activeInstance.active_ticket_id == -1 ){
                validation = false;
                errorNotification('Nincs ticket kiválasztva.');
                $('#ticketsearchfield').addClass('error');
                $('#ticketnumbersearchfield').addClass('error');
                $('#ticket_name').addClass('error');
            }

            if( activeInstance.activity_id.length < 1 ){
                validation = false;
                errorNotification('Nincs tevékenység kiválasztva');
                $('#field_activity').addClass('error');
                $('#activitysearch').val('');
            }


            if(validation == true){

                var duration = ( activeInstance.worktime_hours * 60 * 60 ) + (activeInstance.worktime_minutes * 60 );

                showLoadingOverlay();
                Vue.http.post(baseURL+'/admin/addWorkTime', {
                    'date':activeInstance.date,
                    'duration':duration,
                    'project_id':activeInstance.active_project_id,
                    'ticket_id':activeInstance.active_ticket_id,
                    'activity_id':activeInstance.activity_id,
                    'note':activeInstance.note,
                    'type':'worktime'
                }).then(function(response){

                    $('body').LoadingOverlay("hide");
                    //IF EVERYTHING IS OK
                    if(response.data == 'OK'){
                        activeInstance.getUserWorktimeRecordsForTheDay();

                        //RESET THE FIELDS
                        activeInstance.project_number = '';
                        activeInstance.duration = 0;
                        activeInstance.worktime_hours = -1;
                        activeInstance.worktime_minutes = -1;
                        activeInstance.active_client = {};
                        activeInstance.active_client_id = -1;
                        activeInstance.active_brand = {};
                        activeInstance.active_brand_id = -1;
                        activeInstance.active_project = {};
                        activeInstance.active_project_id = -1;
                        activeInstance.active_ticket = {};
                        activeInstance.active_ticket_id = -1;
                        activeInstance.project_number = -1;
                        activeInstance.ticket_number = -1;

                        $('#projectnumbersearchfield').val('');

                        $('#ticketnumbersearchfield').val('');
                        setTimeout(function(){
                            $('#ticketsearchfield').val('');
                            $('#projectsearchfield').val('');
                        },200);


                        activeInstance.note = '';
                        //activeInstance.date='';
                        activeInstance.activity_id = '';
                        $('#activitysearch').val('');
                        $('#projectsearch').val('');
                        successNotification('A munkaidő rögzítve.');
                    }

                    //IF PROJECT NOT FOUND
                    else if(response.data=='Project not found'){
                        errorNotification('A projektszám nem létezik.')
                    }

                    //IF DAY WERE ALREADY CLOSED
                    else if(response.data=='The day is closed'){
                        errorNotification('A munkanap már le lett zárva');
                    }

                    //activeInstance.recentWorkTimeAdditions.push(response.data);

                }).bind(this);
            }
        },


    },
    computed:{
        total_duration_on_last_business_day:function(){
            var total_duration_on_last_business_day = 0;

            $.each(activeInstance.recentWorkTimeAdditions,function(index,record){
                if( record.date == activeInstance.last_business_day )
                {
                    total_duration_on_last_business_day += record.duration;
                }
            });
            return total_duration_on_last_business_day;
        }
    }
});